import {Request} from "kaiju.core";

const loader = async ({params}: any) => {
    const {collectionId} = params
    const attributeList = await Request("ContentTypeBuilder.single.attribute.list", {
        single: collectionId,
    }).then((resp: any) => {
        return resp.result
    })
    return {
        attributeList
    }
}

export {loader}